import { doc as fsDoc, DocumentReference, Firestore } from "firebase/firestore";
export default function doc<T extends object = {}>(
  db: Firestore,
  ...pathSegments: string[]
) {
  return fsDoc(db, pathSegments.join("/")) as DocumentReference<T>;
}
